import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fbbc4d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CallsFilters__inputs" }
const _hoisted_2 = { class: "CallsFilters__actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CallsFilters",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_input, {
        placeholder: "Курьер",
        value: _ctx.filters_state.courierName,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.courierName) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Накладная/Заказ",
        value: _ctx.filters_state.search,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.search) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Кому звонили",
        value: _ctx.filters_state.phone,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.phone) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Клиент",
        value: _ctx.filters_state.clientName,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.clientName) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата с (Время звонка)",
        value: _ctx.filters_state.createdAtFrom,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.createdAtFrom) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата по (Время звонка)",
        value: _ctx.filters_state.createdAtTo,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.createdAtTo) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Действие",
        options: _ctx.CALLS_TYPE_OPTIONS,
        "select-by": "id",
        value: _ctx.filters_state.type,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.type) = $event))
      }, null, 8, ["options", "value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.filters_state.cityId,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.cityId) = $event)),
        placeholder: "Город",
        loading: _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-by": "name",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
        onSearch: _ctx.searchCity,
        onOptionBySearch: _ctx.unshiftFindedCity
      }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_button, {
        class: "second text small mr-2",
        loading: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сброс ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}